import TopStrip from "@/components/site/TopStrip";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Stats from "@/components/site/Stats";
import Buyers from "@/components/site/Buyers";
import AboutBerry from "@/components/site/AboutBerry";
import ProductMatrix from "@/components/site/ProductMatrix";
import Quality from "@/components/site/Quality";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page">
      <TopStrip />
      <Header />
      <Hero />
      <Stats />
      <Buyers />
      <AboutBerry />
      <ProductMatrix />
      <Quality />
      <Contact />
      <Footer />
    </div>
  );
}
